var actions = {
	next: "Berikutnya",
	confirm: "Konfirmasi",
	"continue": "Lanjutkan"
};
var errors = {
	unknown: "Terjadi kesalahan yang tidak diketahui",
	contactSupport: "Terjadi kesalahan. Harap hubungi bagian dukungan.",
	tryAgain: "Terjadi kesalahan. Coba lagi.",
	submit: "Terjadi kesalahan dengan kiriman Anda."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "Log in dengan {name}",
	signupWith: "Sign up dengan {name}"
};
var alreadyHaveAccount = {
	company: "Sudah punya akun {company}?",
	text: "Sudah punya Streamlabs ID?",
	link: "Log In"
};
var noAccount = {
	text: "Belum punya akun?",
	link: "Sign Up"
};
var validation = {
	email: {
		invalid: "Masukkan alamat email yang valid"
	},
	password: {
		required: "Memerlukan kata sandi",
		min: "Kata sandi harus lebih banyak dari 8 karakter",
		number: "Kata sandi harus berisi angka",
		upper: "Kata sandi harus berisi huruf besar",
		special: "Kata sandi harus berisi karakter spesial"
	},
	username: {
		invalid: "Nama harus terdiri dari sekurangnya 5 karakter"
	},
	code: {
		minmax: "Kode harus terdiri antara 6 hingga 10 karakter"
	}
};
var poweredBy = "Ditenagai oleh <company>Streamlabs</company>";
var card = {
	"404": {
		title: "Perusahaan tidak ditemukan!",
		desc: "Coba kembali nanti atau hubungi bagian dukungan."
	},
	company: {
		logoAlt: "Logo {company}"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "Kode otorisasi 6-digit/kode cadangan 8-digit",
	successText: "Berhasil! Mengarahkan ulang...",
	remember: "Ingat perangkat ini selama 30 hari"
};
var createTfa = {
	scan: {
		title: "Aktifkan Autentikasi 2-Faktor",
		lead: "Klik/salin atau pindai kode di bawah menggunakan aplikasi autentikasi yang Anda inginkan Kami merekomendasikan agar menggunakan aplikasi seperti <app0 />, <app1 />, atau <app2 /> untuk menyimpan kode Anda dengan aman.",
		copied: "Berhasil disalin!",
		instructions: "Atau input kode ini secara manual ke aplikasi autentikasi Anda",
		copy: "Salin kode",
		proceed: "Konfirmasi"
	},
	confirm: {
		title: "Konfirmasikan Autentikasi 2-Faktor Anda",
		lead: "Kirim kode 2FA yang dihasilkan di bawah untuk mengonfirmasikan dan mengaktifkan Autentikasi 2-Faktor Anda.",
		label: "Kode Autentikasi 2-Faktor (6 digit)",
		verify: "Verifikasi Kode",
		next: "Berhasil! Langkah Berikutnya"
	},
	save: {
		title: "Simpan Kode Pemulihan Anda",
		lead: "Simpan kode pemulihan Anda di bawah jikalau Anda kehilangan akses ke Autentikasi 2-Faktor Anda. Setelah Anda menutupnya, kode ini tidak akan tersedia lagi.",
		label: "Kode Pemulihan",
		download: "Download Kode Pemulihan",
		copied: "Kode berhasil disalin!",
		finished: "Selesai"
	}
};
var emailLoginForm = {
	buttonText: "Log In",
	emailPlaceholder: "Email",
	passwordPlaceholder: "Kata Sandi"
};
var emailSignupForm = {
	buttonText: "Sign up",
	emailPlaceholder: "Tetapkan sebuah email",
	passwordPlaceholder: "Tetapkan sebuah kata sandi",
	usernamePlaceholder: "Nama Anda",
	ageLabel: "Tanggal Lahir",
	agePlaceholder: "BB/TT/TTTT",
	agreeText: "Saya setuju dengan <terms>Syarat dan Ketentuan</terms> dan <privacy>Kebijakan Privasi</privacy> Streamlabs.",
	agreeError: "Harap setuju dengan syarat dan ketentuan Streamlabs"
};
var ageInput = {
	invalidDate: "Masukkan tanggal ulang tahun yang valid",
	futureDate: "Tanggal lahir harus sebelum hari ini",
	minDate: "Tanggal sebelum tahun {year} tidak diperbolehkan",
	minAge_one: "Anda harus berusia {years} tahun atau lebih untuk menggunakan Streamlabs",
	minAge_two: "Anda harus berusia {years} tahun atau lebih untuk menggunakan Streamlabs",
	minAge_other: "Anda harus berusia {years} tahun atau lebih untuk menggunakan Streamlabs"
};
var forgotPasswordForm = {
	emailPlaceholder: "Email",
	back: "Kembali ke Login",
	successText: "Berhasil! Kami telah mengirimkan kode reset kata sandi kepada Anda",
	buttonText: "Email Permohonan Reset",
	create: {
		successText: "Berhasil! Kami telah mengirimkan kode verifikasi untuk membantu Anda memulai!",
		buttonText: "Minta Kode Verifikasi"
	},
	errors: {
		notFound: "Tidak ditemukan akun dengan alamat email ini"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "Lupa kata sandi Anda?",
	lead: "Jika Anda harus me-reset kata sandi Anda, input emali Anda di bawah dan kami akan mengirimkan sebuah email untuk memulai proses.",
	resetTitle: "Reset Kata Sandi Anda",
	resetLead: "Anda seharusnya menerima sebuah kode via email. Isi formulir untuk me-reset kata sandi Anda.",
	create: {
		title: "Buat kata sandi",
		lead: "Selamat atas pembuatan Streamlabs ID Anda! Satu langkah lagi dan Anda akan bisa login di semua Streamlabs!",
		resetTitle: "Pilih kata sandi",
		resetLead: "Anda seharusnya menerima sebuah kode via email. Gunakan dan isi formulir untuk menetapkan kata sandi Anda."
	},
	successText: "Berhasil! Mengarahkan ulang...",
	signInTitle: "Sudah punya akun?",
	signInBtn: "Log In"
};
var checkTfaCard = {
	title: "Pemeriksaan Autentikasi 2-Faktor",
	lead: "Masukkan Kode Autentikasi 2-Faktor di bawah untuk melanjutkan.",
	successText: "2FA berhasil dikonfirmasi!",
	back: "Kembali"
};
var verifyEmailCard = {
	title: "Verifikasi Email Anda",
	lead: "Periksa email Anda untuk mendapatkan kode 8-digit dari Streamlabs kemudian input di bawah.",
	back: "Kembali",
	successText: "Email berhasil diverifikasi!"
};
var upgradeCard = {
	confirm: {
		title: "Konfirmasi koneksi {company}",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Ke depannya, Anda akan bisa log in ke {company} dengan email dan kata sandi yang disediakan.",
			"Anda bisa mengakses semua produk lainnya dari Streamlabs dengan ID Anda dan menghubungkan akun Anda yang lainnya, jika ada.",
			"Akun {company} Anda tidak akan terkena dampak dari perubahan ini."
		],
		button: "Konfirmasi",
		cancel: "Batalkan",
		switchAccount: "Ganti Akun",
		success: "Menghubungkan..."
	},
	confirmed: {
		title: "Berhasil!",
		subtitle: "Streamlabs ID Anda telah dibuat dan akun {company} sudah terhubung.",
		text: "Anda bisa menggunakan Streamlabs ID Anda untuk semua produk Streamlabs. Jika sudah memiliki akun, Anda bisa menghubungkannya ke ID ini dari setiap aplikasi.",
		button: "Tutup"
	},
	error: {
		user: "Gagal mengidentifikasi pengguna. Coba kembali log in atau hubungi bagian dukungan."
	}
};
var confirmCard = {
	confirm: {
		title: "Konfirmasi Koneksi {company}",
		subtitle: "Kami menemukan sebuah akun dengan email yang sama. Apakah Anda ingin menggabungkan akun ini dengan Streamlabs ID?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Anda akan bisa log in ke {company} dengan email dan kata sandi yang Anda sediakan melalui Streamlabs ID",
			"Anda bisa mengakses semua produk lainnya dari Streamlabs dengan ID Anda dan menghubungkan akun Anda yang lainnya, jika ada.",
			"Akun perusahaan Anda tidak akan terkena dampak dari perubahan ini."
		],
		button: "Konfirmasi",
		cancel: "Batalkan",
		switchAccount: "Ganti Akun",
		success: "Menghubungkan..."
	},
	confirmed: {
		title: "Berhasil!",
		subtitle: "Streamlabs ID Anda telah dibuat dan akun {company} sudah terhubung.",
		text: "Anda bisa menggunakan Streamlabs ID Anda untuk semua produk Streamlabs. Jika sudah memiliki akun, Anda bisa menghubungkannya ke ID ini dari setiap aplikasi.",
		button: "Tutup"
	},
	error: {
		user: "Gagal mengidentifikasi pengguna. Coba kembali log in atau hubungi bagian dukungan."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " ID Anda sudah terhubung dengan sebuah akun {company}",
		subtitle: "Apakah Anda ingin memutuskan tautan akun yang terhubung dan menautkan ke akun Streamlabs Anda saat ini?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Anda akan bisa log in ke Streamlabs dengan email dan kata sandi yang Anda sediakan untuk Streamlabs ID.",
			"Anda bisa mengakses semua produk lainnya dari Streamlabs dengan ID Anda dan menghubungkan akun Anda yang lainnya, jika ada.",
			"Akun Streamlabs Anda tidak akan terkena dampak dari perubahan ini."
		],
		button: "Konfirmasi",
		cancel: "Batalkan",
		switchAccount: "Ganti Akun",
		success: "Menghubungkan...",
		agreeLabel: "Saya memahami bahwa dengan membuat koneksi ini, saya akan kehilangan akses ke akun {company} saat ini yang terhubung dengan Streamlabs ID."
	},
	confirmed: {
		title: "Berhasil!",
		subtitle: "Streamlabs ID Anda telah dibuat dan akun {company} sudah terhubung.",
		text: "Anda bisa menggunakan Streamlabs ID Anda untuk semua produk Streamlabs. Jika sudah memiliki akun, Anda bisa menghubungkannya ke ID ini dari setiap aplikasi.",
		button: "Tutup"
	},
	error: {
		user: "Gagal mengidentifikasi pengguna. Coba kembali log in atau hubungi bagian dukungan."
	}
};
var loginCard = {
	title: "Log In",
	lead: "Log in ke <company>{company}</company> dengan <id>Streamlabs ID</id>",
	accountExists: "Sepertinya Anda memiliki <b>Streamlabs ID</b>. Cobalah sign in dengan email Anda.",
	forgotPassword: "Lupa kata sandi?",
	successText: "Berhasil! Mengarahkan ulang...",
	signInTitle: "Log in dengan sebuah platform"
};
var loginSourcesCard = {
	title: "Log In",
	lead: "Log in dengan email/kata sandi",
	withSlId: "Log in dengan Streamlabs ID",
	noAccountMessage: "Kami tidak melihat akun yang terhubung dengan metode login ini. Cobalah metode log in lainnya atau <signup>Sign Up</signup> jika Anda belum mendaftar.",
	accountExistsMessage: "Alamat email Twitch Anda sudah terhubungkan dengan Streamlabs. Cobalah sign in dengan email dan kata sandi Streamlabs Anda."
};
var resetPasswordForm = {
	emailPlaceholder: "Email",
	codePlaceholder: "Kode Email 6-8 Digit",
	tfaCodePlaceholder: "Kode 2FAuthenticator",
	newPasswordPlaceholder: "Kata Sandi Baru",
	tfaError: "Kode reset harus terdiri antara 6 hingga 10 karakter",
	next: "Sudah menerima kode?",
	back: "Kembali ke Lupa Kata Sandi",
	buttonText: "Ganti Kata Sandi",
	successText: "Kata Sandi Berhasil di-Reset",
	create: {
		back: "Kembali ke awal",
		buttonText: "Tetapkan Kata Sandi",
		successText: "Kata Sandi Berhasil Dibuat"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "Kata Sandi Sekarang",
	newPasswordPlaceholder: "Kata Sandi Baru",
	newPasswordConfirmationPlaceholder: "Konfirmasikan Kata Sandi Baru",
	buttonText: "Ganti Kata Sandi",
	successText: "Kata sandi berhasil diperbarui",
	newPasswordConfirmationError: "Kata sandi baru tidak cocok",
	back: "Kembali ke dasbor"
};
var changePasswordCard = {
	title: "Ganti Kata Sandi Anda",
	lead: "Masukkan kata sandi sekarang bersama dengan kata sandi baru di bawah.",
	successText: "Kata sandi berhasil diperbarui"
};
var removeTfaForm = {
	tfaCodePlaceholder: "Kode otorisasi 6-digit/kode cadangan 8-digit",
	successText: "2FA berhasil dihapuskan",
	removeBtn: "Konfirmasi & Hapus"
};
var removeTfaCard = {
	title: "Hapus Autentikasi 2-Faktor",
	lead: "Masukkan kode konfirmasi 2FA di bawah untuk menghapus Autentikasi Dua-Faktor dari akun Anda.",
	successText: "2FA berhasil dihapuskan",
	back: "Kembali ke dasbor"
};
var verifyEmailForm = {
	codePlaceholder: "Kode 8-digit dari email",
	tfaCodePlaceholder: "Kode 2FAuthenticator",
	emailPlaceholder: "Alamat Email",
	buttonText: "Verifikasi Email",
	successText: "Email Berhasil Diverifikasi",
	requestBtn: "Minta Kode Baru",
	requestingBtn: "Meminta...",
	requestSuccess: "Sebuah kode telah dikirimkan ke email Anda",
	requestAgain: "Minta Kembali dalam {seconds} detik",
	tfaError: "Kode reset harus terdiri antara 6 hingga 10 karakter",
	back: "Kembali"
};
var signupCard = {
	title: "Sign Up",
	lead: "Buat akun <id>Streamlabs ID</id> untuk menggunakan <company>{company}</company>",
	successText: "Berhasil! Mengarahkan ulang..."
};
var signupSourcesCard = {
	title: "Sign Up",
	lead: "Buat akun <id>Streamlabs ID</id> untuk menggunakan <company>{company}</company>",
	withSlId: "Buat Streamlabs ID"
};
var connectCard = {
	connect: {
		title: "Pilih sebuah akun",
		lead: "untuk melanjutkan ke <b>{company}</b>",
		authorize: "Otorisasi",
		authorizeSuccess: "Berhasil!",
		cancel: "Batalkan",
		disclaimer: {
			streamlabs: "Dengan melanjutkan, Anda akan membagikan Streamlabs ID (nama, alamat email, preferensi bahasa, dan foto profil) dengan <b>{company}</b>. Dengan menyetujui sebuah akun bersama <b>{company}</b>, Anda dengan ini menyetujui <privacy>kebijakan privasi</privacy> dan <terms>ketentuan layanan</terms> dari <b>{company}</b>.",
			"default": "Untuk melanjutkan, Streamlabs akan membagi nama, alamat email, preferensi bahasa, dan foto profil Anda dengan <b>{company}</b>. Dengan menyetujui sebuah akun bersama <b>{company}</b>, Anda dengan ini menyetujui <privacy>kebijakan privasi</privacy> dan <terms>ketentuan layanan</terms> dari <b>{company}</b>."
		},
		emailRequired: "Memerlukan verifikasi email sebelum melanjutkan",
		tfaRequired: "Memerlukan Autentikasi 2-Faktor sebelum melanjutkan"
	},
	login: {
		title: "Log in ke {company}",
		lead: "Anda harus login untuk menghubungkan akun",
		loginBtn: "Lanjutkan ke login"
	},
	error: {
		title: "Log in ke {company}",
		lead: "Permintaan Anda tidak bisa diotorisasi pada saat ini.",
		verifyEmail: "Verifikasi Email",
		verify2fa: "Verifikasi 2FA"
	},
	"switch": {
		btn: "Gunakan akun lainnya"
	}
};
var appsDropdown = {
	label: "Produk & aplikasi Streamlabs",
	viewMore: "Bentangkan",
	viewLess: "Tutup"
};
var platformButtons = {
	loginWithPlatform: "Log in dengan sebuah platform",
	signUpWithPlatform: "Sign up dengan sebuah platform",
	signUpLead: "Kami mendukung live streaming ke lebih banyak platform, semua ini hanyalah opsi sign up."
};
var ultraCheckoutCard = {
	title: "Tingkatkan kualitas lives treaming, pencitraan merek, pengeditan, dan hal lainnya dengan <b>Streamlabs Ultra</b>",
	badge: "Termasuk <b>{planName}</b>",
	totalValue: "bernilai {price, currency}",
	price: {
		month: "{price, currency}/bln",
		year: "{price, currency}/th"
	},
	description: {
		month: "Akses fitur premium di seluruh jajaran lengkap platform kami yang mencakup <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, dan masih banyak lagi. Semuanya tersedia dalam satu harga yang terjangkau.",
		year: "Akses fitur premium di seluruh jajaran lengkap platform kami yang mencakup <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, dan masih banyak lagi. Semuanya tersedia dalam satu harga yang terjangkau."
	},
	seeIncluded: "Pelajari Selengkapnya",
	buyNow: "Tingkatkan"
};
var ultraCheckoutBanner = {
	title: "Tingkatkan kualitas lives treaming, pencitraan merek, pengeditan, dan hal lainnya dengan <b>Streamlabs Ultra</b>",
	badge: "Termasuk <b>{planName}</b>",
	totalValue: "bernilai {price, currency}",
	price: {
		month: "{price, currency}/bln",
		year: "{price, currency}/th"
	},
	description: {
		month: "Akses fitur premium di seluruh jajaran lengkap platform kami yang mencakup <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, dan masih banyak lagi. Semuanya tersedia dalam satu harga yang terjangkau. <link />",
		year: "Akses fitur premium di seluruh jajaran lengkap platform kami yang mencakup <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, dan masih banyak lagi. Semuanya tersedia dalam satu harga yang terjangkau. <link />"
	},
	seeIncluded: "Pelajari Selengkapnya",
	buyNow: "Tingkatkan"
};
var connect = {
	waitMessage: "Menggabungkan data. Tolong jangan tutup jendela ini."
};
var verifyPasswordCard = {
	success: "Kata sandi berhasil diverifikasi",
	title: "Harap autentikasi ulang untuk memverifikasi",
	lead: "Log in dengan email dan kata sandi yang sudah ada untuk melanjutkan pembaruan Streamlabs ID Anda.",
	buttonText: "Berikutnya"
};
var emailChangeForm = {
	agreeError: "Pastikan bahwa Anda memahami tindakan ini",
	buttonText: "Berikutnya",
	emailPlaceholder: "Alamat Email Baru",
	agreeText: "Saya memahami bahwa setelah diverifikasi, Streamlabs ID saya akan berubah di semua produk Streamlabs yang terhubung dengannya."
};
var verifyNewEmailCard = {
	title: "Ubah Streamlabs ID Anda",
	lead: "Sediakan email baru untuk digunakan sebagai Streamlabs ID Anda. Kami akan mengirimkan kode verifikasi 6-8 digit ke alamat ini.",
	successText: "Email baru tersedia"
};
var verifyNewEmailOwnershipCard = {
	title: "Verifikasi Streamlabs ID Anda yang telah diperbarui",
	lead: "Periksa email Anda untuk mendapatkan kode 8-digit dari Streamlabs kemudian input di bawah.",
	buttonText: "Konfirmasi",
	back: "Kembali",
	codePlaceholder: "Kode 8-digit dari email",
	successText: "Kepemilikan email berhasil diverifikasi"
};
var verifyTfaCard = {
	title: "Kode autentikasi 2-faktor",
	lead: "Masukkan kode verifikasi 6 digit dari aplikasi autentikasi Anda",
	codePlaceholder: "Kode 6 digit",
	buttonText: "Konfirmasi",
	successText: "Autentikasi 2-Faktor telah dikonfirmasi",
	back: "Kembali"
};
var ageGateForm = {
	ageLabel: "Tanggal Lahir",
	agePlaceholder: "BB/TT/TTTT"
};
var ageGateCard = {
	title: "Selesaikan penyiapan akun",
	lead: {
		years: "Anda harus berusia {years} atau lebih untuk membuat akun. <br />Masukkan tanggal lahir Anda untuk menyelesaikan penyiapan.",
		noYears: "Anda harus memasukkan tanggal lahir Anda untuk membuat akun. <br />Masukkan untuk menyelesaikan penyiapan."
	},
	successText: "Selamat! Penyiapan akun sudah selesai."
};
var idID = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { idID as i };
//# sourceMappingURL=id-ID.es.js.map
